import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../FieldGroup.jsx';
import { FormError } from '../../FormError.jsx';
import ExampleCSVDownloadButton from './ExampleCSVDownloadButton.jsx';

function StakeholdersCsvForm({
  handleSubmit,
  formRef,
  submitError,
  submitFailed,
  submitting,
  onCancel,
}) {
  return (
    <form onSubmit={handleSubmit} ref={formRef}>
      <Row>
        <Col xs={8} className="m-b-24">
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
            <h3>Bulk CSV Upload</h3>
          </div>

          <ExampleCSVDownloadButton />
        </Col>
      </Row>

      <Row className="m-b-18">
        <Col xs={10}>
          <Field
            id="groupsFormCsvFile"
            name="csv_file"
            type="file"
            component={FieldGroup}
            accept=".csv"
          />
        </Col>
      </Row>

      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
        <Col xs={12}>
          <div className="flex">
            <div>
              <Button bsStyle="default" onClick={onCancel}>
                Cancel
              </Button>

              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={submitting}
                type="submit"
              >
                {submitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
}

export default StakeholdersCsvForm;
